<template>
  <div class="page-content">
    <!-- 头部区域 -->
    <div class="searchCon">
      <el-row>
        <el-col :span="2">产品:</el-col>
        <el-col :span="21" class="keyContent">
          <el-row :span="24" type="flex" align="center" v-if="isShowMore">
            <el-col :span="10"><el-input v-model="queryProductInput" placeholder="请输入产品名称进行搜索"  size="mini" ></el-input></el-col>
          </el-row>
          <el-col :class="['keyBtn','ellipsis',productKey===''?'activeKey':'']">
            <span  @click="selectClick('')">全部</span>
          </el-col>
          <template  v-if="isShowMore">
            <el-col
              v-for="item in productList.filter(item=>{
                return queryProductInput.trim() === ''?true:item.productName.indexOf(queryProductInput.trim()) > -1
              })"
              :key="item.productKey+(new Date().getTime()+Math.random())"
              :class="['keyBtn','ellipsis',productKey===item.productKey?'activeKey':'']">
              <el-tooltip :content="item.productName" placement="bottom" effect="light">
                <span @click="selectClick(item.productKey)">{{item.productName}}</span>
              </el-tooltip>
            </el-col>
          </template>
          <template v-else>
            <el-col
              v-for="item in productList.slice(0,9)"
              :key="item.productKey+(new Date().getTime()+Math.random())"
              :class="['keyBtn','ellipsis',productKey===item.productKey?'activeKey':'']">
              <el-tooltip :content="item.productName" placement="bottom" effect="light">
                <span @click="selectClick(item.productKey)">{{item.productName}}</span>
              </el-tooltip>
            </el-col>
          </template>

        </el-col>
        <el-col :span="1" class="moreBtn">
          <span  @click="moreBtnClick">{{isShowMore?'隐藏-':'更多+'}}</span>
        </el-col>
      </el-row>
    </div>
    <el-row :span="24" class="serchContent" type="flex">
       <el-select
        @clear="searchTaskList"
        clearable
        v-model="taskQuery.taskStatus"
        @change="searchTaskList"
        size="small"
        placeholder="请选择任务状态"
        class="mal10">
          <el-option label="关闭" :value="1"/>
          <el-option label="开启" :value="2"/>
      </el-select>
      <el-col class="search mal10"  >
        <el-col :span="8">
          <el-autocomplete
            style="width:100%"
          @keyup.13.native="searchTaskKeyUp"
            size="small"
            v-model="taskQuery.taskName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入任务名称"
            @select="handleSelect"
          ></el-autocomplete>
          <!-- <el-input v-model="taskQuery.taskName" placeholder="请输入任务名称" @keyup.13.native="searchTaskKeyUp" size="small" ></el-input> -->
          </el-col>
          <el-button class="" type="primary" size="small" icon="el-icon-search" @click="searchTaskList"></el-button>
          <el-button class="" type="primary" size="small" icon="el-icon-plus" @click="drawerFlag=true">添加任务对比</el-button>
          <el-button class="" v-if="Object.keys(compareTask).length > 0"  size="small" icon="el-icon-delete" @click="compareTask = {}">清除对比</el-button>
      </el-col>
    </el-row>
    <!-- <el-row>
          <el-tag
            class="tag"
            v-for="taskId in Object.keys(compareTask)"
            :key="taskId"
            @close="closeTag(taskId)"
            closable
            type="">
            {{compareTask[taskId].taskName}}
          </el-tag>
        </el-row> -->
    <navCompare :compareTask="compareTask" v-if="Object.keys(compareTask).length > 0"/>
    <div class="nav" v-else>
        <el-row>
          <el-col :span="24">
              <el-tabs type="card" v-model="activeName" @tab-click="handleClick" :before-leave="beforeLeave">
                <!-- <paging :total="total" @changePage="changePage"/> -->
                 <el-tab-pane
                 :disabled="!hasPre"
                 label="上一页"
                 name="pre"
                  />
                <el-tab-pane
                :label="item.taskName"
                :name="item.taskId.toString()"
                v-for="item in tableOptions"
                :key="item.taskId"
                >
                    <transition name="fade-transform" mode="in-out">
                      <!-- keep-alive可以再次切换回来时候不会再次进行数据加载 -->
                      <keep-alive>
                        <!-- 当content存在时候，表示数组已经加载，再进行绘制图表，防止图表堆积一起显示异常 -->
                          <!-- 饼状图 -->
                          <component
                          v-if="item.taskId.toString() === activeName && item.groupField"
                          :taskDetail='item'
                          :is='charts[1]'
                          :taskId='activeName'>
                          </component>
                          <!-- 条形图和折线图 -->
                          <component
                          v-else-if="item.taskId.toString() === activeName"
                           :taskDetail='item'
                          :is='charts[0]'
                          :taskId='activeName'>
                          </component>
                        <div class="tx-c" v-else>
                         <span>图表加载中</span><span class="el-icon-loading"></span>
                        </div>
                      </keep-alive>
                    </transition>
                </el-tab-pane>

                <el-tab-pane
                :disabled="!hasNext"
                 label="下一页"
                 name="next"
                  />
              </el-tabs>
              <emptyView v-if="showEmpty"></emptyView>
          </el-col>
        </el-row>
  </div>

  <!-- 选择任务对比 -->
  <chooseTaskDrawe @confirmAdd="confirmAdd"  v-if="drawerFlag" :productKey="productKey"  :compareTask="compareTask" :drawerFlag="drawerFlag" @closeDrawer="closeDrawer" @getData="receive"/>
  </div>
</template>
<script>
import { taskProductInfo, taskList, taskName } from '@/api/dataStatistics'
import lineChart from '@/components/dataList/nav1.vue'
import pieChart from '@/components/dataList/nav2.vue'
import navCompare from '@/components/dataList/navCompare.vue'

import emptyView from '@/components/empty_view/empty'
import chooseTaskDrawe from '@/components/dataList/chooseTaskDrawe'
// import { eventBus } from '@/utils/eventBus'
// import paging from '@/components/paging'
// import { mapGetters } from 'vuex'
export default {
  components: {
    chooseTaskDrawe,
    emptyView,
    navCompare
    // paging
  },
  data () {
    return {
      productCurrenIndex: 1,
      positionCurrentIndex: 1,
      selProvinceValue: '',
      provinceOptions: [],
      activeName: '0',
      currentTabIndex: '0', // 默认选中的tab的下标
      queryType: '',
      charts: [lineChart, pieChart],
      tableOptions: [],
      productKey: '',
      productList: [],
      showEmpty: false,
      total: 0,
      listQuery: { // 筛选任务列表
        page: 1,
        limit: 10
      },
      taskQuery: { // 筛选任务列表
        taskStatus: 2,
        taskName: ''
      },
      drawerFlag: false,
      compareTask: {},
      isShowMore: false, // 是否显示更多产品
      queryProductInput: '',
      restaurants: []
    }
  },
  created () {
    this.getOptionsProductList()
    this.initByProductKey()
  },
  watch: {
  },
  computed: {
    hasPre () {
      return this.listQuery.page > 1
    },
    hasNext () {
      return (this.listQuery.page * this.listQuery.limit) < this.total
    }
  },
  methods: {
    searchTaskKeyUp (e) {
      if (e.keyCode === 13) {
        this.searchTaskList()
      }
    },
    moreBtnClick () {
      console.log(77777)
      this.queryProductInput = ''
      this.isShowMore = !this.isShowMore
    },
    // closeTag (taskId) {
    //   this.$delete(this.compareTask, taskId)
    //   eventBus.$emit('getCompareChartData')
    // },
    confirmAdd (addTask) {
      if (Object.keys(this.compareTask).length > 0) {
        this.compareTask = Object.assign({}, addTask)
        // eventBus.$emit('getCompareChartData')
      } else {
        this.compareTask = Object.assign({}, addTask)
      }
      this.drawerFlag = false
    },
    // 获取抽屉传过来的值
    receive (val) {
      console.log('子组件数据', val)
      // this.form.categoryId = val.categoryId
      // this.form.categoryParentId = val.categoryParentId
      // this.categoryName = val.categoryName
      // this.drawerFlag = false
      // this.focusStatus = true
    },
    // 关闭抽屉
    closeDrawer () {
      this.drawerFlag = false
    },
    changePage (val) {
      console.log('val:', val)
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      // 重新刷新
      this.initByProductKey()
    },
    // 条件筛选任务
    async searchTaskList () {
      this.listQuery.page = 1
      await this.getTaskList()// 先获取任务列表
      this.getActiveName()
      this.loadAll()
    },
    // 根据productKey的变化来请求刷新页面
    async initByProductKey () {
      await this.getTaskList()// 先获取任务列表
      this.getActiveName()
    },
    getActiveName () {
      // if (sessionStorage.getItem('queryType')) {
      //   this.activeName = sessionStorage.getItem('queryType')// 存本地用户体验不好，还是采用会话存储
      //   this.currentTabIndex = sessionStorage.getItem('currentTabIndex')
      // } else {
      console.log('tableOptions:', this.tableOptions)
      // 默认取第一个任务
      this.activeName = this.tableOptions.length > 0 ? this.tableOptions[0].taskId.toString() : ''
      this.currentTabIndex = 0
      // }
    },
    handleClick (tab) {
      console.log('888')
      this.currentTabIndex = tab.index
      this.taskQuery.taskName = ''
      // 如果对应的content属性存在，表明已经首次加载初始化了，不需要再次初始化
      console.log('this.currentTabIndex:', this.currentTabIndex)
    },
    selectClick (value) {
      console.log(99999)
      this.productKey = value
      // 页码重置为1
      this.listQuery.page = 1
      this.initByProductKey()// 切换产品重新初始化
    },
    getOptionsProductList () {
      taskProductInfo()
        .then(res => {
          this.productList = res.data.data
          console.log('this.productList:', this.productList)
        })
    },
    async getTaskList () {
      const params = {
        productKey: this.productKey,
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit,
        taskStatus: this.taskQuery.taskStatus,
        taskName: this.taskQuery.taskName,
        isPaging: true
      }
      // 先获取任务列表
      await taskList(params).then(res => {
        // 循环遍历属性为响应式的
        // this.forEachObject(this.tableOptions, res.data.data)
        res = res.data
        const list = res.data.list ? res.data.list : []
        this.tableOptions.splice(0, this.tableOptions.length, ...list)
        if (res.data.recordCount) {
          this.total = res.data.recordCount
        } else {
          this.total = 0
        }
        console.log('this.tableOptions.length', this.tableOptions.length)
        this.tableOptions.length ? this.showEmpty = false : this.showEmpty = true
      })
    },
    beforeLeave (activeName, oldActiveName) {
      if (activeName !== 'next' && activeName !== 'pre') {
        return true
      } else {
        if (activeName === 'next') {
          this.listQuery.page++
        } else {
          this.listQuery.page--
        }
        // 重新刷新
        this.taskQuery.taskName = ''
        this.initByProductKey()
        return false
      }
    },
    async loadAll () {
      const params = {
        taskStatus: this.taskQuery.taskStatus,
        taskName: ''
      }
      const result = []
      await taskName(params).then(res => {
        res = res.data
        if (res.data && res.data.length > 0) {
          res.data.forEach(ele => {
            result.push({
              value: ele
            })
          })
        }
        console.log('查询返回的结果：', res)
      })
      this.restaurants = result
    },
    querySearchAsync (queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants
      cb(results)
      // clearTimeout(this.timeout)
      // this.timeout = setTimeout(() => {
      //   cb(results)
      // }, 3000 * Math.random())
    },
    createStateFilter (queryString) {
      console.log('queryString:', queryString)
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect (item) {
      console.log(item)
    }
  },
  mounted () {
    this.loadAll()
  }
}
</script>

<style lang='less' scoped>
.page-content{
  .keyContent{
    //max-height: 100px;
    overflow-y: auto;
    max-height: 150px;
  }
  .moreBtn{
    color:#409EFF;
    cursor: pointer;
    font-size: 14px !important;
  }
  .keyBtn{
    cursor: pointer;
    width: 10%;
    padding-left: 10px;
  }
  .activeKey{
    color:#409EFF
  }
  .mal10{
    margin-left: 10px;
  }
  .serchContent{
    margin-top: 20px;
    .el-button{
      // margin-left: 10px;
    }
    .search{
      flex: auto;
    }
    .iconPlus{
      font-size: 20px;
    }
    .el-icon-search{
      margin-left: 10px;
    }
  }
   .tx-c{
     text-align: center;
   }
   .searchCon{
    background-color: #f6f7fa;
    border: 1px solid #dddddd;
    .el-row{
      display: flex;
      align-items: center;
    }
    .el-col{
      font-size: 16px;
      padding: 10px 0;
    }
    .el-button{
      padding: 6px 10px;
      border: 0px;
      margin-bottom:10px ;
    }
    .el-col:nth-child(even){
      background-color: white;
      padding-left: 20px;
    }
    .el-col{
      padding-left: 10px;
    }
  }

  .nav{
    margin-top: 20px;
    //padding: 20px 5px 10px 15px;
    /deep/ .el-tabs__nav-wrap::after{
      background: white;
    }
    /deep/ .el-tab-pane{
      height: 604px;
      font-size: 16px;
      overflow-y: auto;
    }
  }
  // .tag{
  //       margin-right: 5px;
  //       margin-top: 5px;
  //     }
}
</style>
